import { logger as P } from "./logger.js";
var I = /* @__PURE__ */ ((o) => (o.Nearest = "nearest", o))(I || {});
const d = (o, n, u, r, e) => {
  const l = new Uint8ClampedArray(r * e * 4), y = n / r, S = u / e, s = n * 4;
  let c = 0;
  for (let t = 0; t < e; t++) {
    const f = Math.floor(t * S) * s;
    for (let a = 0; a < r; a++) {
      const m = f + Math.floor(a * y) * 4;
      l[c++] = o[m], l[c++] = o[m + 1], l[c++] = o[m + 2], l[c++] = o[m + 3];
    }
  }
  return l;
};
function L(o, n, u, r, e) {
  const l = new Uint8ClampedArray(r * e);
  if (n === r && u === e) {
    for (let s = 0; s < o.length; s++)
      l[s] = Math.min(Math.max(o[s], 0), 255);
    return l;
  }
  const y = (n - 1) / (r - 1), S = (u - 1) / (e - 1);
  for (let s = 0; s < e; s++)
    for (let c = 0; c < r; c++) {
      const t = y * c, f = S * s, a = Math.floor(t), m = Math.floor(f), w = Math.min(Math.ceil(t), n - 1), x = Math.min(Math.ceil(f), u - 1), p = t - a, i = f - m, M = o[m * n + a], h = o[m * n + w], T = o[x * n + a], A = o[x * n + w], k = M * (1 - p) * (1 - i) + h * p * (1 - i) + T * (1 - p) * i + A * p * i;
      l[s * r + c] = Math.min(Math.max(k, 0), 255);
    }
  return l;
}
function R(o, n, u, r, e) {
  const l = new Uint8ClampedArray(r * e), y = n / r, S = u / e, s = (t, f) => {
    if (t === 0) return 1;
    if (t < 0 && (t = -t), t < f) {
      const a = Math.PI * t;
      return f * Math.sin(a) * Math.sin(a / f) / (a * a);
    }
    return 0;
  }, c = 3;
  for (let t = 0; t < e; t++)
    for (let f = 0; f < r; f++) {
      const a = f * y, m = t * S, w = Math.floor(a), x = Math.floor(m);
      let p = 0, i = 0;
      for (let M = x - c + 1; M <= x + c; M++)
        for (let h = w - c + 1; h <= w + c; h++)
          if (h >= 0 && h < n && M >= 0 && M < u) {
            const T = o[M * n + h], A = s(a - h, c) * s(m - M, c);
            p += T * A, i += A;
          }
      l[t * r + f] = i !== 0 ? Math.round(p / i) : 0;
    }
  return l;
}
function C(o, n, u) {
  const r = o.createShader(n);
  if (r || P.errorAndThrow("Error creating shader"), o.shaderSource(r, u), o.compileShader(r), !o.getShaderParameter(r, o.COMPILE_STATUS)) {
    const e = o.getShaderInfoLog(r) ?? "unknown error compiling shader.";
    P.errorAndThrow(e);
  }
  return r;
}
function b(o, n, u) {
  const r = o.createProgram();
  if (r || P.errorAndThrow("Error creating GPU program"), o.attachShader(r, n), o.attachShader(r, u), o.linkProgram(r), !o.getProgramParameter(r, o.LINK_STATUS)) {
    const e = o.getProgramInfoLog(r) ?? "unknown error linking program.";
    P.errorAndThrow(e);
  }
  return r;
}
function z(o) {
  if (o.startsWith("blob:"))
    return !0;
  try {
    return new URL(o), !0;
  } catch {
    return !1;
  }
}
const E = (o, n) => !n || o.startsWith("http") ? new URL(o).href : o ? n.replace(/\/+$/, "") + "/" + o.replace(/^\/+/, "") : n;
export {
  I as InterpolationMethod,
  L as bilinearUpsample,
  C as compileShader,
  z as isResolvedUri,
  R as lanczos3Upsample,
  b as linkProgram,
  d as resizeImage,
  E as toAbsoluteURI
};
//# sourceMappingURL=util.js.map
